import { IconNames } from "../types";
import { ToastVariant } from "./types";

export const TOAST_VARIANT = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning"
} as const;

export const TOAST_VARIANT_COLORS = {
  [TOAST_VARIANT.SUCCESS]: "success",
  [TOAST_VARIANT.ERROR]: "danger",
  [TOAST_VARIANT.WARNING]: "warning"
} as const;

export const TOAST_VARIANT_ICONS: Record<ToastVariant, IconNames> = {
  [TOAST_VARIANT.SUCCESS]: "Circled.Check",
  [TOAST_VARIANT.ERROR]: "Circled.Info",
  [TOAST_VARIANT.WARNING]: "Warning"
} as const;

export const TOAST_DEFAULT_TIMEOUT = 5000;
export const TOAST_DEFAULT_VARIANT = TOAST_VARIANT.SUCCESS;

export const TOAST_CLOSE_ANIMATION_NAME = "toast-close";
